import { Box, HStack, Text } from "@chakra-ui/react";
import { CheckCircle2 } from "lucide-react";
import { surfaceShadow } from "../constants";

export function SelectableCard({
  selected,
  onSelect,
  id,
  title,
  description,
  icon: Icon,
}: {
  selected: string;
  onSelect: (id: string) => void;
  id: string;
  title: string;
  description: string;
  icon: React.ElementType;
}) {
  const isSelected = selected === id;
  return (
    <Box
      borderWidth="2px"
      borderColor={isSelected ? "palomma.500" : "transparent"}
      borderRadius="xl"
      p={5}
      cursor="pointer"
      onClick={() => onSelect(id)}
      position="relative"
      bg={isSelected ? "palomma.50" : "white"}
      boxShadow={isSelected ? "none" : surfaceShadow}
      transition="all 0.2s"
      _hover={isSelected ? {} : { boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.1)" }}
    >
      {isSelected && (
        <Box
          position="absolute"
          right={4}
          top={4}
          w={5}
          h={5}
          borderRadius="full"
          bg="palomma.500"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CheckCircle2 size={12} color="white" />
        </Box>
      )}
      <HStack gap={4} alignItems="flex-start">
        <Box
          p={2.5}
          borderRadius="xl"
          bg={isSelected ? "palomma.500" : "gray.100"}
          color={isSelected ? "white" : "gray.600"}
        >
          <Icon size={20} />
        </Box>
        <Box>
          <Text fontWeight="semibold" color={isSelected ? "palomma.800" : "gray.900"}>
            {title}
          </Text>
          <Text fontSize="sm" color="gray.500" mt={1}>
            {description}
          </Text>
        </Box>
      </HStack>
    </Box>
  );
}
